module.exports = __webpack_public_path__ + "img/0009.6545efc9.png";